import { Component, Input, OnInit } from '@angular/core';
import { MandateModel } from './mandate.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { map, Observable } from "rxjs";
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'convfact-mandate-form',
    templateUrl: './mandate-form.component.html',
    styleUrls: ['./mandate.component.css'],
    standalone: false
})
export class MandateFormComponent implements OnInit {

    @Input() mandate: MandateModel;
    @Output() onSave = new EventEmitter<any>();
    @Input() errors: object;

    showQR: boolean = false;

    payMethod = ["Efectivo", "Transferencia bancaria", "Remesa en cuenta", "Tarjeta de crédito"];
    payMethodCtrl: UntypedFormControl;
    filteredPayMethod: Observable<any>;

    constructor() { }

    ngOnInit() {
        this.payMethodCtrl = new UntypedFormControl();
        this.filteredPayMethod = this.payMethodCtrl.valueChanges
            .pipe(map(method => this.filterPayMethod(method)));
    }

    filterPayMethod(val) {
        const self = this;
        for (const method of this.payMethod) {
            if (method == val) {
                self.mandate.typePay = method;
            }
        }

        return val ? this.payMethod.filter(s => s.toLowerCase().indexOf(val.toLowerCase()) === 0)
            : this.payMethod;
    }


    save(mandate) {
        this.onSave.emit(mandate)
    }

    changeToggle(element) {

    }
  public trackByIndex(i: number) { return i; }

}
